import { Controller } from '@hotwired/stimulus';

// Fills a Rails date_select (the _1i/_2i/_3i selects) with today's date.
export default class extends Controller {
  fill() {
    const today = new Date();
    this.setPart('1i', today.getFullYear());
    this.setPart('2i', today.getMonth() + 1);
    this.setPart('3i', today.getDate());
  }

  setPart(suffix, value) {
    const select = this.element.querySelector(`select[id$="_${suffix}"]`);
    if (select) select.value = String(value);
  }
}
